import clsx from "clsx";
import { useState } from "react";

import { FunnelScreen, PrimaryButton } from "../screen";

import type { ScreenProps } from "../types";

// The interstitial behind "Neither": one box, in their words. Reached only from
// the visitor-type screen, so it never asks someone who already picked a card.
//
// Validation matches the account card — nothing is wrong until Continue is
// pressed, and the message goes the moment it stops applying.
export default function RoleStep({
  step,
  answer,
  busy,
  save,
  back,
}: ScreenProps) {
  const field = (step.fields ?? [])[0];
  const [value, setValue] = useState(
    () => answer?.fields.find((f) => f.key === field?.key)?.value ?? ""
  );
  const [submitted, setSubmitted] = useState(false);

  const error = value.trim() ? undefined : `${field?.label} cannot be blank`;
  const shown = submitted ? error : undefined;

  const submit = () => {
    setSubmitted(true);
    if (!field || error || busy) return;
    save({ fields: [{ key: field.key, value: value.trim() }] });
  };

  return (
    <FunnelScreen back={back} title={step.title}>
      <form
        className="mt-6"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <label htmlFor={field?.key} className="sr-only">
          {field?.label}
        </label>
        <input
          id={field?.key}
          name={field?.key}
          type="text"
          value={value}
          placeholder={field?.placeholder ?? undefined}
          onChange={(event) => setValue(event.target.value)}
          aria-invalid={shown ? true : undefined}
          aria-describedby={shown ? "role-error" : undefined}
          className={clsx(
            "h-11 w-full rounded-lg border px-3 text-body text-zinc-900 transition-colors placeholder:text-zinc-400 focus:outline-none focus:ring-2",
            shown
              ? "border-red-500 focus:border-red-500 focus:ring-red-500/20"
              : "border-zinc-300 focus:border-blue-600 focus:ring-blue-600/20"
          )}
        />
        {shown && (
          <p
            id="role-error"
            className="mt-1.5 text-caption font-normal text-red-600"
          >
            {shown}
          </p>
        )}

        <div className="mt-5">
          <PrimaryButton type="submit" disabled={busy}>
            Continue
          </PrimaryButton>
        </div>
      </form>
    </FunnelScreen>
  );
}
